export const GETAUDIT                      = "[Audits] Audits";
export const GETAUDIT_SUCCESS                = "[Audits] Audits success";
export const GETAUDIT_ERROR                  = "[Audits] Audits error";
export const SET_AUDIT                       = "[Audits] Audits set";

export const getAudits = (data) => ({
    type: GETAUDIT,
    payload: data
  });
  export const getAuditsSuccess = (data) => ({
    type: GETAUDIT_SUCCESS,
    payload: data,
  });
  
  export const getAuditsError = (data) => ({
    type: GETAUDIT_ERROR,
    payload: data,
  });

  export const setAudits = (data) => ({
    type: SET_AUDIT,
    payload: data,
  });
